export const MANUFACTURERS = [
  'Arizonian',
  'BF Goodrich',
  'Bridgestone',
  'Capitol',
  'Continental',
  'Cooper',
  'Dayton',
  'Douglas',
  'Dunlop',
  'Falken',
  'Federal',
  'Firestone',
  'Fuzion',
  'General',
  'Goodyear',
  'Hankook',
  'Hercules',
  'Kelly',
  'Kenda',
  'Kumho',
  'Mastercraft',
  'Maxxis',
  'Michelin',
  'Milestar',
  'Nankang',
  'Nexen',
  'Nitto',
  'Nokian',
  'Other',
  'Pirelli',
  'Primewell',
  'Starfire',
  'Sumitomo',
  'Toyo',
  'Uniroyal',
  'Vogue',
  'Yokohama'
];
export const TIRE_SIZES = ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22'];
export const TREAD_DEPTHS = [
  '1/32',
  '2/32',
  '3/32',
  '4/32',
  '5/32',
  '6/32',
  '7/32',
  '8/32',
  '9/32',
  '10/32',
  '11/32',
  '12/32',
  '13/32',
  '14/32',
  '15/32',
  '16/32',
  '>16/32'
];
